<template>
    <div class="dialog">
        <el-dialog :title="title" :visible.sync="visible" :lock-scroll="true" width="1150px" :before-close="handleClose"
            append-to-body>
            <section>
                <div class="serach">
                    <el-form ref="formTool" :model="formTool" :inline="true">
                        <el-select v-model="formTool.goodsOneClassId" size="small" placeholder="商品一级分类" clearable
                            class="input-box" @change="changeOneClassId">
                            <el-option v-for="item in goodsOneClassIdOptions" :key="item.id" :label="item.name"
                                :value="item.id" />
                        </el-select>
                        <el-select v-model="formTool.goodsTwoClassId" size="small" placeholder="商品二级分类" clearable
                            class="input-box" @change="changeTwoClassId">
                            <el-option v-for="item in goodsTwoClassIdOptions" :key="item.id" :label="item.name"
                                :value="item.id" />
                        </el-select>
                        <el-select v-model="formTool.goodsThreeClassId" size="small" placeholder="商品三级分类" clearable
                            class="input-box">
                            <el-option v-for="item in goodsThreeClassIdOptions" :key="item.id" :label="item.name"
                                :value="item.id" />
                        </el-select>

                        <el-input class="input-box" v-model.trim="formTool.goodsName" clearable size="small"
                            placeholder="商品名称"></el-input>


                        <el-input class="input-box" v-model.trim="formTool.factory" clearable size="small"
                            placeholder="厂家名称"></el-input>


                        <el-input class="input-box" v-model.trim="formTool.goodsCode" clearable size="small"
                            placeholder="基库ID"></el-input>


                        <el-button type="primary" size="small" @click="search">查询</el-button>


                        <el-button type="primary" size="small" @click="reset">重置</el-button>

                    </el-form>
                </div>
                <el-tabs v-model="activeName" @tab-click="handleClick">

                    <el-tab-pane label="选择商品" name="first"></el-tab-pane>

                    <el-tab-pane label="已选商品" name="second">
                        <template #label>
                            <span class="custom-tabs-label">
                                <el-badge :value="selectedGoodsList.length" class="item">
                                    <span>已选商品</span>
                                </el-badge>
                            </span>
                        </template>
                    </el-tab-pane>
                </el-tabs>
                <div v-if="activeName == 'first'" class="content-box">
                    <goodsItem :goodsList="goodsList" :goodsKey="goodsKey" :chooseGoodsIds="selectedGoodsListIDs" @chooseItem="chooseItem"
                        class="goods-content" ref="goods-list" />
                    <el-pagination class="pagination-box" @size-change="handleSizeChange"
                        @current-change="handleCurrentChange" :current-page.sync="page.current" :page-sizes="page.pageSizes"
                        layout="total, sizes, prev, pager, next" :total="page.total">
                    </el-pagination>
                </div>
                <div v-if="activeName == 'second'" class="content-box">
                    <!-- 展示之前选中的商品 -->
                    <goodsChooseItem :goodsList="selectedGoodsList" @removeGoods="removeGoods" class="goods-content"
                        ref="goods-list2" />
                </div>
            </section>
            <div class="btnBox">
                <el-button size="small" @click="handleClose">取消</el-button>
                <el-button type="primary" size="small" @click="chooseGoods">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { goodsclassOne, goodsclassTwo } from '@/api/commodityreference'
import { goodsbasePlmActivityGoodsPage, queryPlatformActivitySkuPage } from "@/api/platActivityManage";
import goodsItem from "./goodsItem.vue";
import goodsChooseItem from "./goodsChooseItem.vue";
export default {
    components: {
        goodsItem,
        goodsChooseItem
    },
    props: {
        btnType: {
            type: String,
            default: ''
        },
        dialogType: {  // goodsBaseTag 基础库商品类型 、 goodsShopTag 店铺指定商品类型
            type: String,
            default: 'goodsShopTag'
        },
    },
    computed: {
        selectedGoodsListIDs() {
            return this.selectedGoodsList.map(i => i[this.goodsKey])
        },
        // 商品唯一值
        goodsKey(){
          if(this.dialogType==='goodsShopTag'){
            // 店铺指定商品
            return 'skuId'
          }
          return 'goodsId'
        }
    },
    data() {
        return {
            isGoodsBase: false, // 是否是商品基准库
            goodsOneClassIdOptions: [],
            goodsTwoClassIdOptions: [],
            goodsThreeClassIdOptions: [],
            showForm: false, //是否展示表单
            visible: false,
            isDisabled: false,
            pageType: '',
            formTool: {
                factory: '', // 生产厂家
                goodsName: '', // 商品名称
                goodsCode: '', // 商品id（对应基本库id）
                goodsOneClassId: '', // 商品一级分类id
                goodsTwoClassId: '', // 商品二级分类id
                goodsThreeClassId: '', // 商品三级分类id
            },
            title: '',
            goodsList: [], // 商品列表
            selectedGoodsList: [], // 已选商品
            selectItems: [],
            page: {
                total: 10,
                current: 1,
                size: 12,
                pageSizes: [12, 20, 30, 50],
            },
            skuIds: [],
            skuIdArr: [],
            shopIds: [], // 商户id集合
            activeName: 'first',
            pageType: '',

        }
    },
    mounted() {},
    methods: {
        init(...ags) {
            const { pageType, shopIds } = ags[0];
            this.pageType = pageType;
            this.title = '指定商品'
            // this.page.current = 1;
            shopIds && (this.shopIds = shopIds);
            this.getGoods();
            this.visible = true;
            this.query();
        },
        handleClick() {
            if (this.activeName == 'first') {
                this.getGoods();
            }
        },
        // 搜索
        change(e) {
            console.log(e)
            this.handleClick()
        },
        // 页码变化
        handleCurrentChange(e) {
            this.page.current = e;
            this.getGoods()
        },
        // 条数变化
        handleSizeChange(e) {
            this.page.size = e
            this.page.current = 1;
            this.getGoods()
        },
        getParams() {
            const params = {
                size: this.page.size,
                current: this.page.current,
                ...this.formTool,
                subsidyId: this.$route.query.id
            };
            if (this.dialogType === 'goodsShopTag') {
                // 店铺指定商品
                params.shopList = this.shopIds;
                params.goodsName = this.formTool.goodsName
            } else if (this.dialogType === 'goodsBaseTag') {
                params.nameLike = this.formTool.goodsName
            }
            return params
        },
        // 获取店铺商品列表 /  获取基准库商品
        getGoods() {
            const params = this.getParams();
            const req = this.dialogType === 'goodsBaseTag' ? goodsbasePlmActivityGoodsPage : queryPlatformActivitySkuPage
            req(params).then((res) => {
                if (res) {
                    this.goodsList = res.records || [];
                    this.page.total = res.total;
                }
            });
        },

        handleClose() {
            this.page.current = 1;
            this.visible = false;
        },
        // 选择商品
        chooseItem(item) {
            const index = this.selectedGoodsList.findIndex((i) => i[this.goodsKey] === item[this.goodsKey]);
            if (index >= 0) {
                this.selectedGoodsList.splice(index, 1);
            } else {
                this.selectedGoodsList.push(item);
            }
            this.$emit('didSelectItem', this.selectedGoodsList)
        },
        // 删除商品
        removeGoods(item){
            const index = this.selectedGoodsList.findIndex((i) => i[this.goodsKey] === item[this.goodsKey]);
            if (index >= 0) {
                this.selectedGoodsList.splice(index, 1);
            } 
            this.$emit('didSelectItem', this.selectedGoodsList)
        },
        chooseGoods() {
            console.log(this.selectedGoodsList, 'this.selectedGoodsList')
            if (!this.selectedGoodsList.length) {
                this.$message.warning('请选择推广商品')
                return
            }
            this.visible = false;
            this.$emit('didSelectItem', this.selectedGoodsList)
        },
        query() {
            goodsclassOne().then(res => {
                if (res.code == 0) {
                    this.goodsOneClassIdOptions = res.data
                }
            }).catch(err => {
                console.log(err)
            })
        },
        // 切换一级分类
        changeOneClassId(val) {
            if (val) {
                this.goodsclassTwo(val)
            } else {
                this.formTool.goodsTwoClassId = ''
                this.goodsTwoClassIdOptions = []
                this.formTool.goodsThreeClassId = ''
                this.goodsThreeClassIdOptions = []
            }
        },
        // 切换二级分类
        changeTwoClassId(val) {
            if (val) {
                this.goodsclassThree(val)
            } else {
                this.formTool.goodsThreeClassId = ''
                this.goodsThreeClassIdOptions = []
            }
        },
        // 查询一级分类
        goodsclassOne() {
            goodsclassOne().then(res => {
                if (res.code == 0) {
                    this.goodsOneClassIdOptions = res.data
                    if (this.goodsOneClassIdOptions.length > 0) {
                        this.formTool.goodsOneClassId = this.goodsOneClassIdOptions[0].id
                    } else {
                        this.formTool.goodsOneClassId = ''
                    }
                }
            }).catch(err => {
                console.log(err)
            })
        },
        // 查询二级分类
        goodsclassTwo(id) {
            goodsclassTwo(id).then(res => {
                if (res.code == 0) {
                    this.goodsTwoClassIdOptions = res.data
                    if (this.goodsTwoClassIdOptions.length > 0) {
                        this.formTool.goodsTwoClassId = ''
                        this.formTool.goodsThreeClassId = ''
                        this.goodsThreeClassIdOptions = []
                        // this.goodsclassThree(this.goodsTwoClassIdOptions[0].id)
                    } else {
                        this.formTool.goodsTwoClassId = ''
                        this.formTool.goodsThreeClassId = ''
                        this.goodsThreeClassIdOptions = []
                    }
                }
            }).catch(err => {
                console.log(err)
            })
        },
        // 查询三级分类
        goodsclassThree(id) {
            goodsclassTwo(id).then(res => {
                if (res.code == 0) {
                    this.goodsThreeClassIdOptions = res.data
                    if (this.goodsThreeClassIdOptions.length > 0) {
                        this.formTool.goodsThreeClassId = ''
                    } else {
                        this.formTool.goodsThreeClassId = ''
                    }
                }
            }).catch(err => {
                console.log(err)
            })
        },
        // 搜索
        search() {
            this.page.current = 1;
            this.getGoods();
        },
        // 重置
        reset() {
            this.formTool = {};
            this.page.current = 1;
            this.getGoods();
        }
    }
}
</script>
<style lang="scss" scoped>
::v-deep {
    .el-badge__content.is-fixed {
        top: 4px;
    }
}

.input-box {
    width: 150px;
    margin-right: 8px;
}

.pagination-box {
    text-align: right;
}

.btnBox {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}

.serach {
    margin-bottom: 10px;
}

.goods-content {
    overflow-y: auto;
    min-height: 50px;
}

.content-box {}
</style>